import React from "react";

interface AsteriskProps {
    leftPadding?: boolean
}

export default function Asterisk(props: AsteriskProps): JSX.Element {
    return (
        <span className={"component-asterisk" + (props.leftPadding ? " left-padded-asterisk" : "")}>*</span>
    )
}